import { getHandlers } from '../utils.js'

const FIELDS_FIELDS = [
  'Canonical URL',
  'UserAgent',
  'browserFamily (browser)',
  'OS (operating system)',
  'URL Query Parameters',
  'refDomain',
  'mappedEvent',
  'channel',
  'searchQuery',
  'keywords',
  'entities',
  'concepts',
  'Google categories (categories)',
  'analzyed text**',
  'AndroidID/Google Ad ID**',
  'IOS IDFA**',
  'ConnectedTV**',
  'metadata** (publisher declared metatags)',
  'Nielsen (nls id)',
  'The Trade Desk',
  'Eyeota (approval needed & not offered in samples)',
  'Lotame',
  'AppNexus (adns id)',
  'MediaMath',
  'ASN Number',
  'ASN Organization',
  'consentData',
  'consentDomain',
  'geo_dma',
  'geo_city',
  'geo_country',
  'geo_dmaCode',
  'geo_subISO',
  'geo_ISO',
  'geo_long',
  'geo_lat',
  'geo_postal',
  'de.geo.pulseplus_iso (de_geo iso)',
  'de_geo.pulseplus_country (de_geo country)',
  'de_geo.pulseplus_country_code (de_geo country code)',
  'de_geo.pulseplus_country_conf (de_geo pulseplus_country_conf)',
  'de_geo.pulseplus_proxy_type (de_geo proxy type)',
  'de_geo.pulseplus_proxy_description (de_geo proxy description)',
  'de_geo.pulseplus_dst (de_geo pulseplus_in_dst)',
  'de_geo.pulseplus_conn_type (de_geo conn type)',
  'de_geo.pulseplus_conn_speed (de_geo conn speed)',
  'de_geo.pulseplus_city (de_geo city)',
  'de_geo.pulseplus_city_code (de_geo city code',
  'de_geo.pulseplus_city_conf (de_geo pulseplus_city_conf)',
  'de_geo.pulseplus_metro_code (de_geo metro code)',
  'de_geo.pulseplus_postal_code (de_geo postal code)',
  'de_geo.pulseplus_postal_ext (de_geo postal ext)',
  'de_geo.pulseplus_postal_conf (de_geo pulseplus_postal_conf)',
  'de_geo.pulseplus_area_code (de_geo area codes)',
  'de_geo.pulseplus_gmt_offset (de_geo gmt offset)',
  'de_geo.pulseplus_lat (de_geo latitude)',
  'de_geo.pulseplus_long (de_geo longitude)',
  'de_geo.pulseplus_continent_code (de_geo continent code)',
  'de_geo.pulseplus_region_code (de_geo region code)',
  'de_geo.pulseplus_region_conf (de_geo pulseplus_region_conf)',
  'de_geo.pulseplus_timezone (de_geo timezone)',
  'de_geo.pulseplus_isp (de_geo isp)',
  'de_geo.pulseplus_asn (de_geo asn)',
  'de_geo.pulseplus_asn_name (de_geo asn name)',
  'de_geo.pulseplus_company_name (de_geo company name)',
  'de_geo.pulseplus_organization_name (de_geo org name)',
  'de_geo.pulseplus_naics (de_geo naics code)',
]

const handleFieldsChange = (onChange, _, all) => {
  const options = all
    .filter((pair) => FIELDS_FIELDS.includes(pair[1]))
    .map((pair) => pair[1].replace(/\./g, '_'))

  onChange({}, 'fields', options)
}

export default getHandlers(FIELDS_FIELDS, handleFieldsChange)
